import { render } from "./SendMessagePage.vue?vue&type=template&id=3f7f1de6&ts=true"
import script from "./SendMessagePage.vue?vue&type=script&lang=ts"
export * from "./SendMessagePage.vue?vue&type=script&lang=ts"

import "./SendMessagePage.vue?vue&type=style&index=0&id=3f7f1de6&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/ZaloOA_Phoi/ZaloOA_Phoi_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__